import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class CalendarSettingService {
  /**
   * コンストラクタ
   */
  constructor(private http: HttpClient) { }

  /**
   * カレンダ設定ファイル取り込みAPI呼び出し
   * @param formData フォームデータ
   */
  public exportCalendarSetting(formData: FormData): Observable<any> {
    let httpOptions: any = {
        // ヘッダ情報
        headers: new HttpHeaders({
          'contet-type': 'multipart/form-data',
        })
      };
    return this.http.post(environment.apiEndPoint + 'api/calendar-setting/import-file', formData, httpOptions) as Observable<any>;
  }
}
